import { render, staticRenderFns } from "./MultipleTagSelector.vue?vue&type=template&id=46d219dc&"
import script from "./MultipleTagSelector.vue?vue&type=script&lang=js&"
export * from "./MultipleTagSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports